<template>
    <div id="WindDirectionModal">
        <el-dialog title="实时数据监测饼状图" :visible.sync="modalChart_windDirection.show" @close="closeDialog()" width="35%" id="WindDirectionModalBox" @opened="opened()">
            <div id="bigChart_wind" style="width:100%;height:400px">

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import echarts from 'echarts'

    export default {
        name: 'WindDirectionModal',
        props:{
            modalChart_windDirection:Object,
            optionMini_windDirection:Object,
            measure_no:'',
            content:'',
            early_warn_value:'',
            warn_value:'',
            unit:''
        },
        data () {
            return {
                windPosition:''
            }
        },
        // 用watch()函数来监听数据的更新，一旦数据更新了，那么就在watch()函数中调用drawLine()函数，用于更新视图
        watch:{
            optionMini_windDirection(curVal,oldVal){
                this.drawLine(curVal);
            }
        },
        methods:{
            opened(){
                this.drawLine(this.optionMini_windDirection);
            },
            drawLine(val){
                // 拿到数组的最后一个数据作为风向,拼接成数组
                const data = val.series[0].data;
                const windRirec = data[data.length - 1];
                // 数值对应十六位风向
                if (windRirec >= 0 && windRirec <= 11.25) {
                    this.windPosition = '北'
                }
                if (windRirec > 11.25 && windRirec <= 33.75) {
                    this.windPosition = '北东北'
                }
                if (windRirec > 33.75 && windRirec <= 56.25) {
                    this.windPosition = '东北'
                }
                if (windRirec > 56.25 && windRirec <= 78.25) {
                    this.windPosition = '东东北'
                }
                if (windRirec > 78.25 && windRirec <= 101.25) {
                    this.windPosition = '东'
                }
                if (windRirec > 101.25 && windRirec <= 123.75) {
                    this.windPosition = '东东南'
                }
                if (windRirec > 123.75 && windRirec <= 146.25) {
                    this.windPosition = '东南'
                }
                if (windRirec > 146.25 && windRirec <= 168.75) {
                    this.windPosition = '南东南'
                }
                if (windRirec > 168.75 && windRirec <= 191.25) {
                    this.windPosition = '南'
                }
                if (windRirec > 191.25 && windRirec <= 213.75) {
                    this.windPosition = '南西南'
                }
                if (windRirec > 213.75 && windRirec <= 236.25) {
                    this.windPosition = '西南'
                }
                if (windRirec > 236.25 && windRirec <= 258.75) {
                    this.windPosition = '西西南'
                }
                if (windRirec > 258.75 && windRirec <= 281.25) {
                    this.windPosition = '西'
                }
                if (windRirec > 281.25 && windRirec <= 303.75) {
                    this.windPosition = '西西北'
                }
                if (windRirec > 303.75 && windRirec <= 326.25) {
                    this.windPosition = '西北'
                }
                if (windRirec > 326.25 && windRirec <= 348.75) {
                    this.windPosition = '北西北'
                }
                if (windRirec > 348.75 && windRirec <= 360) {
                    this.windPosition = '北'
                }
                const arr = [
                    {name:'风向',value:windRirec,selected:true,label: {show: true , fontSize: '12'}},
                    {name:'',value:360 - windRirec}
                ];
                let option = {
                    legend: {
                        show: false
                    },
                    // series: val.series,
                    series:[
                        {
                            type: 'pie',
                            selectedMode: 'single',
                            radius: '60%',
                            data: arr,
                            label: {
                                normal: {
                                    position: 'inner',
                                    show:false,
                                }
                            },
                        }
                    ],
                    title:{
                        text:`${this.content}-${this.measure_no}测点数据详细图`
                    },
                    label: {
                        alignTo: 'edge',
                        formatter: '{b}\n {c} 度' + '\n\r' + this.windPosition,
                        // formatter: '{name|{b}}\n{time|{c} 度}' + '-' + this.windPosition +'',
                        minMargin: 5,
                        edgeDistance: 10,
                        lineHeight: 15,
                        rich: {
                            time: {
                                fontSize: 10,
                                color: '#000'
                            }
                        }
                    },
                }
                let bigChart_wind = echarts.init(document.getElementById('bigChart_wind'));
                bigChart_wind.setOption(option,true);  // Echarts清除上次加载的数据
            },
            closeDialog(){
                this.modalChart_windDirection.show = false;
            },
        }
    }
</script>

<style>

    #WindDirectionModal .el-dialog__header {
        padding: 20px 30px 10px;
        /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      text-align: center;
      transition: unset;
    }

    #WindDirectionModal .el-dialog__body {
        padding: 10px 20px;
    }

    #WindDirectionModal .el-dialog__title{
      text-align: center;
        font-size: 18px;
        color: #fff;
    }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitor/WindDirectionModal.vue